import { Typography } from "@mui/material";
import EvaluationStarsSubtypeDetails from "../details/EvaluationStarsSubtypeDetails";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { EvaluationStarsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationStarModels";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: EvaluationStarsSubtypeDataModel;
}

export default function EvaluationStarsSubtypeSummary(props: Props) {
    return <EvaluationStarsSubtypeDetails {...props} />
}
